import { render, staticRenderFns } from "./CharactersSliderEmpty.vue?vue&type=template&id=0df726c6&"
import script from "./CharactersSliderEmpty.vue?vue&type=script&lang=js&"
export * from "./CharactersSliderEmpty.vue?vue&type=script&lang=js&"
import style0 from "./CharactersSliderEmpty.vue?vue&type=style&index=0&id=0df726c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports